let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lP5PB")).then(() => parcelRequire('4Ruu6'));